import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
const override = (React.CSSProperties = {
    display: 'block',
    margin: '0 auto',
});
const Button = ({ text, onClick, onKeyDown, searching, innerRef, ...rest }) => {
    return (_jsx("button", { onClick: onClick, onKeyDown: onKeyDown, ref: innerRef, ...rest, children: searching ? (_jsx(PulseLoader, { color: "#ffffff", cssOverride: override, loading: true, size: 10 })) : (text) }));
};
export default Button;
